import { ShopifyAnalytics } from '@unlikelystudio/react-ecommerce-hooks'

export function ShopifyAnalyticsProvider() {
  // TODO: When a consent management tool is implemented, replace the following line with the logic to determine if the user has given consent.
  const hasUserConsent = false

  return <ShopifyAnalytics hasUserConsent={hasUserConsent} />
}
